import { Inject, Injectable } from '@angular/core';
import { Environment } from '@uc/shared/data-models';

@Injectable({
	providedIn: 'root',
})
export class EnvironmentApiService {
	PHP_URL!: string;
	API_URL!: string;
	JSON_URL!: string;
	DOMAIN!: string;

	constructor(@Inject('environment') private _environment: Environment) {
		this.API_URL = this._environment.api_url;
		this.PHP_URL = this._environment.php_url;
		this.DOMAIN = this._environment.domain;
		this.JSON_URL = `${this._environment.domain}/assets/json/`;
	}
}
